import { CityView, CountryView, StateView, UserView } from '@api-proxies';
import {
    IAdditionalFiltersConfig,
    IGenericAdditionalFilters
} from '@shared/additional-filters/additional-filters.config';

export const BUILDINGS_FILTER_KEY = 'buildings';

export const BUILDINGS_FILTER_CONFIG: IAdditionalFiltersConfig<IAdditionalFiltersBuildings> = {
    entityType: 'buildings',

    visibility: {
        city: true,
        state: true,
        country: true,
        salesperson: true,
        includeArchived: true
    },

    transformToFilters: (formValue: any): IAdditionalFiltersBuildings => {
        return {
            city: formValue.city && formValue.city.length > 0 ? formValue.city[0] : undefined,
            state: formValue.state && formValue.state.length > 0 ? formValue.state[0] : undefined,
            country: formValue.country && formValue.country.length > 0 ? formValue.country[0] : undefined,
            salespersons:
                formValue.salespersons && formValue.salespersons.length > 0 ? formValue.salespersons : undefined,
            includeArchived: formValue.includeArchived || undefined
        };
    },

    transformFromFilters: (filters: IAdditionalFiltersBuildings): any => {
        return {
            city: filters?.city ? [filters.city] : [],
            state: filters?.state ? [filters.state] : [],
            country: filters?.country ? [filters.country] : [],
            salespersons: filters?.salespersons || [],
            includeArchived: filters?.includeArchived || undefined
        };
    },

    hasFiltersApplied: (filters: IAdditionalFiltersBuildings | null): boolean => {
        if (!filters) return false;
        const props = ['city', 'state', 'country', 'salespersons'];
        if (props.some((prop) => filters[prop])) return true;
        return filters.includeArchived === true;
    }
};

export interface IFilterValueBuildings {
    searchText?: string;
    city?: CityView;
    state?: StateView;
    country?: CountryView;
    includeArchived?: boolean;
    sortBy?: string;
    sortDirection?: string;
    salespersons?: UserView[];
}

export interface IAdditionalFiltersBuildings extends IGenericAdditionalFilters {
    city?: CityView;
    state?: StateView;
    country?: CountryView;
    salespersons?: UserView[];
    includeArchived?: boolean;
}
